import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionEquipment, constructionSafety } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/retailExhibition/video/rtlsVideo.mp4';

export default {
  desc: 'AIoT (Trí tuệ nhân tạo Vạn vật) là một khái niệm kết hợp Trí tuệ nhân tạo (AI) và Internet vạn vật (IoT).',
  keywords: 'AIoT, IoT, AI, Công nghệ hội trí tuệ nhân tạo, RTLS,AI Camera',
  ogSite: 'AIoT là gì? Định nghĩa, Công nghệ, Ứng dụng và Ưu điểm',
  title: 'AIoT là gì? Định nghĩa, Công nghệ, Ứng dụng và Ưu điểm',
  ogUrl: 'https://orbro.io/vi/blog/what-is-aiot',
  ogImg: 'https://lh3.google.com/u/0/d/1beXwJR6Bc3ap2Kb_H7OaW4vPVlq3ovWM=w2000-h7622-iv1',
  ogType: 'website',
  date: '2024-05-09',
  tag1: '#AIoT',
  tag2: '#IoT',
  tag3: '#AI',
  tag4: '#Congnghehoitrituenhantao',
  text: [
    {
      head: 'AIoT là gì?',
      subHead: '',
      desc: 'AIoT (Trí tuệ nhân tạo Vạn vật) là một khái niệm kết hợp Trí tuệ nhân tạo (AI) và Internet vạn vật (IoT). Điều này có nghĩa là các thiết bị IoT tương tác thông minh, học hỏi lẫn nhau và trở nên thông minh hơn bằng cách sử dụng các công nghệ AI như Machine Learning, phân tích dữ liệu và công nghệ nhận thức. AIoT tích hợp công nghệ AI vào công nghệ IoT hiện có, cho phép tự động hóa hiệu quả hơn và ra quyết định dựa trên dữ liệu. Thông qua đó, có thể nâng cao năng suất và cung cấp các dịch vụ tiện lợi.',
      dot: '',
    },
    {
      head: 'Những công nghệ tiêu biểu của AIoT',
      subHead: 'Trí tuệ nhân tạo (AI)',
      desc: 'Công nghệ AI bao gồm Machine Learning, Deep Learning, xử lý ngôn ngữ tự nhiên, v.v. Bằng cách sử dụng các công nghệ này, AI phân tích dữ liệu, nhận diện các mẫu, và cho phép các thiết bị IoT tương tác một cách thông minh.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Internet vạn vật (IoT)',
      desc: 'IoT là công nghệ cho phép nhiều vật thể kết nối vào mạng lưới để trao đổi dữ liệu. Các vật thể như cảm biến, thiết bị, thiết bị gia dụng, v.v., được kết nối Internet để tương tác, thu thập, truyền và xử lý dữ liệu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cảm biến và bộ truyền động (Actuator)',
      desc: 'Cảm biến thu thập dữ liệu từ môi trường xung quanh và bộ truyền động là thiết bị tác động đến môi trường bên ngoài. Chúng là những thành phần quan trọng của thiết bị IoT.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Điện toán đám mây (Cloud Computing)',
      desc: 'Trong AIoT, các dịch vụ đám mây được sử dụng để xử lý và phân tích dữ liệu quy mô lớn. Các máy chủ dựa trên đám mây lưu trữ và xử lý dữ liệu, cung cấp các quyết định cho người dùng.',
      dot: '',
    },
    {
      head: 'Những ứng dụng của AIoT',
      subHead: 'Smart Home (Nhà thông minh)',
      desc: 'Sử dụng công nghệ AI để kết nối nhiều thiết bị khác nhau trong nhà, mang lại môi trường sống tiện lợi. Ví dụ, một Smart Home hub có thể điều khiển đèn, hệ thống sưởi, hệ thống an ninh trong nhà, và học hỏi thói quen của người dùng để đề xuất phương pháp tiêu thụ năng lượng tối ưu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý sức khỏe thông minh',
      desc: 'Sử dụng các thiết bị đeo tay và cảm biến để giám sát tình trạng sức khỏe cá nhân, và phân tích dữ liệu này để cung cấp dịch vụ chăm sóc sức khỏe cá nhân hóa. Nó thu thập dữ liệu như nhịp tim, mô hình giấc ngủ, mức độ hoạt động, và thông qua thuật toán AI, có thể dự đoán tình trạng sức khỏe hoặc phát hiện bệnh sớm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Smart Agriculture (Nông nghiệp)',
      desc: 'Sử dụng cảm biến IoT để thu thập thông tin như độ ẩm đất, nhiệt độ, độ pH của cây trồng, và phân tích dữ liệu này để giám sát tình trạng cây trồng và tối ưu hóa quy trình trồng trọt. Nông dân có thể kiểm tra tình trạng cây trồng theo thời gian thực thông qua ứng dụng smartphone và thực hiện các biện pháp cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Smart City (Thành phố)',
      desc: 'Kết nối nhiều cơ sở vật chất và cơ sở hạ tầng khác nhau trong thành phố để nâng cao hiệu quả của thành phố và tăng cường tiện ích cho người dân. Ví dụ, hệ thống chiếu sáng thông minh cảm nhận môi trường xung quanh để điều chỉnh ánh sáng, và hệ thống giao thông thông minh giám sát tình hình giao thông theo thời gian thực để ngăn ngừa tắc nghẽn giao thông hoặc đề xuất lộ trình tối ưu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Smart Manufacturing (Sản xuất)',
      desc: 'Trong ngành sản xuất, cảm biến IoT và robot được sử dụng để tự động hóa dây chuyền sản xuất và giám sát quy trình sản xuất. Thuật toán AI phân tích dữ liệu sản xuất để tối ưu hóa sản lượng và dự đoán trước sản phẩm lỗi, từ đó nâng cao hiệu quả sản xuất.',
      dot: '',
    },
    {
      head: 'Ưu điểm của AIoT',
      subHead: '',
      desc: 'AIoT kết hợp Trí tuệ nhân tạo và Internet vạn vật, mang lại nhiều ưu điểm như tự động hóa thông minh, ra quyết định dựa trên dữ liệu, phân tích dự đoán, cung cấp dịch vụ cá nhân hóa, v.v.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa thông minh',
      desc: ' AIoT có thể kiểm soát và quản lý các thiết bị IoT một cách thông minh bằng cách sử dụng công nghệ Trí tuệ nhân tạo. Điều này cho phép tự động hóa và tối ưu hóa công việc, giảm sự can thiệp của con người và nâng cao năng suất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ra quyết định dựa trên dữ liệu',
      desc: ' AIoT được sử dụng để thu thập và phân tích lượng lớn dữ liệu, từ đó đưa ra các quyết định. Thông qua đó, có thể nắm bắt tình hình theo thời gian thực và thực hiện các biện pháp tối ưu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích dự đoán và bảo trì',
      desc: 'AIoT sử dụng dữ liệu cảm biến và thuật toán AI để phát hiện sớm các dấu hiệu bất thường của hệ thống và thực hiện phân tích dự đoán. Thông qua đó, có thể ngăn ngừa sự cố thiết bị và tối ưu hóa lịch trình bảo trì.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cung cấp dịch vụ cá nhân hóa',
      desc: 'AIoT có thể phân tích dữ liệu người dùng để cung cấp các dịch vụ cá nhân hóa. Ví dụ, hệ thống Smart Home kiểm soát chiếu sáng, sưởi ấm, v.v., phù hợp với thói quen và sở thích của người dùng, mang lại môi trường tiện lợi và an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hiệu quả năng lượng',
      desc: 'AIoT giúp tối ưu hóa tiêu thụ năng lượng. Bằng cách sử dụng dữ liệu cảm biến và thuật toán AI để phân tích mô hình sử dụng năng lượng và đề xuất phương pháp tiết kiệm năng lượng tối ưu, nó nâng cao hiệu quả năng lượng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiết kiệm thời gian và chi phí',
      desc: 'AIoT có thể tiết kiệm nhân lực và thời gian thông qua việc tự động hóa và tối ưu hóa công việc. Ngoài ra, việc ngăn ngừa sự cố thiết bị từ sớm thông qua phân tích dự đoán cũng giúp cắt giảm chi phí.\nCông nghệ AIoT, kết hợp Trí tuệ nhân tạo và Internet vạn vật, mang lại nhiều ưu điểm như tự động hóa thông minh, ra quyết định dựa trên dữ liệu, phân tích dự đoán, cung cấp dịch vụ cá nhân hóa, v.v. Thông qua đó, có thể đạt được năng suất cao hơn, giảm chi phí, nâng cao hiệu quả năng lượng, và hiện thực hóa đổi mới và hiệu quả trong nhiều ngành công nghiệp và lĩnh vực đời sống khác nhau.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
